import axios from 'axios';
import UrlFactory from './url_factory';
import Constants from './constants';

class API extends UrlFactory {
    static _instance = null;
    static Instance() {
        if (!API._instance) {
            API._instance = new API();
        }
        return API._instance;
    }

    makeHeaders() {
        return {
            method: 'GET',
            credentials: 'include',
        };
    }

    makeClockoutHeaders() {
        return {
            headers: { token: Constants.CONSUMER_AUTH_TOKEN },
            validateStatus: function (status) {
                return status === 200 || status === 304 || status === 404; // Resolve only if the status code is 200 or 304
            },
        };
    }

    async fetchContext() {
        const response = await fetch(this.createContextUrl(), this.makeHeaders());
        const data = await response.json();
        return data;
    }

    async fetchFi(aba) {
        const response = await axios.get(this.createFiUrl(aba), this.makeClockoutHeaders());
        return await response.data;
    }
}

export default API;
